import {Injectable, Injector} from '@angular/core';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import {of} from 'rxjs';
import {catchError, map, mergeMap} from 'rxjs/operators';

import * as ac from './actions.command.bereich-rolle-hinzufuegen';
import * as api from '../../../clients/displaysteuerung';

@Injectable()
export class DisplaysteuerungBereichRolleHinzufuegenEffects {

    BereichRolleHinzufuegen$ = createEffect(() => this.actions$.pipe(
        ofType(ac.POST_BEREICH_ROLLE_HINZUFUEGEN),
        mergeMap((x: ac.PostBereichRolleHinzufuegenAction) => {
            const optPayload = (x !== undefined && x !== null && x.optPayload !== undefined) ? x.optPayload : null;
            return this.getService().postBereichRolleHinzufuegen(x.bereichRolleRequest).pipe(
                map((result: any) => {
                    return new ac.PostBereichRolleHinzufuegenErfolgreichAction(result, x.bereichRolleRequest, optPayload);
                }),
                catchError((error: any) => {
                    const nextAction = new ac.PostBereichRolleHinzufuegenFehlerAction(error, x.bereichRolleRequest, optPayload);
                    return of(nextAction);
                })
            );
        })
    ));

    private service: api.VerwaltenCommandService = null;

    constructor(private actions$: Actions, private injector: Injector) {
    }

    private getService(): api.VerwaltenCommandService {
        if (this.service === null) {
            this.service = this.injector.get(api.VerwaltenCommandService);
        }
        return this.service;
    }
}
